import { Socket } from 'phoenix';
import { isEmpty, l } from 'src/utils/helper';
import { EventEmitter } from 'events';
import { cache } from '..';
import {
  channels,
  channelType as channelTypes,
  commandType,
  GUARDIAN_TOKEN,
  CURRENT_SOCKET,
  receivedMessagesUrl,
} from './common';

const socketEventEmitter = new EventEmitter();
const JOIN_CRASHED = 'join crashed';

const isSubscribe = (id, channelType) => channels.get(`${channelType}:${id}`) !== undefined;

const unSubscribe = (id, channelType) => {
  // TODO: Иногда отписывает от несуществующего канала
  if (isSubscribe(id, channelType)) {
    channels.get(`${channelType}:${id}`).leave();
    channels.delete(`${channelType}:${id}`);
  }
};

const disconnect = () => {
  const currentSocket = cache.get(CURRENT_SOCKET);

  if (currentSocket) {
    currentSocket.disconnect();
  }

  cache.remove(CURRENT_SOCKET);
};

function retryAgain(tries) {
  const interval = [1000, 1000, 1000, 1000, 2000, 3000, 4000];
  return interval[tries - 1] || 5000;
}

const createSocket = (token) => {
  const params = {};

  if (cache.get(CURRENT_SOCKET)) {
    return cache.get(CURRENT_SOCKET);
  }

  if (!isEmpty(token)) {
    params[GUARDIAN_TOKEN] = token;

    const socket = new Socket(receivedMessagesUrl, {
      params,
      reconnectAfterMs: retryAgain,
      logger: (kind, msg, data) => {
        l.log(`${kind}: ${msg}`, data);
      },
    });
    socket.connect();
    cache.set(CURRENT_SOCKET, socket);
    socket.onOpen(() => {
      l.info('Сокет подключен');
      socketEventEmitter.emit('socketConnected');
    });
    l.info(`Пользователем cоздан сокет с параметрами: ${JSON.stringify(params)}`);
    return socket;
  }

  l.error('Невозможно подключиться к сокету. Токен отсутствует');

  return this;
};

const createChannel = (socket, channelType, id, token) => {
  const params = {};

  if (channels.get(`${channelType}:${id}`)) {
    return channels.get(`${channelType}:${id}`);
  }

  if (!isEmpty(token)) {
    params[GUARDIAN_TOKEN] = token;

    const channel = socket.channel(`${channelType}:${id}`, { ...params });
    channels.set(`${channelType}:${id}`, channel);
    l.info(`Создан канал ${channelType}:${id} с параметрами: ${JSON.stringify(params)}`);
    return channel;
  }

  l.error('Невозможно подключиться к комнате. Токен отсутствует');

  return this;
};

function subscribePresence({ channel, callback }) {
  channel.on(commandType.PRESENCE_STATE, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.PRESENCE_STATE}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.PRESENCE_STATE, activityId, body: payload });
    }
  });

  channel.on(commandType.PRESENCE_DIFF, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.PRESENCE_DIFF}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.PRESENCE_DIFF, activityId, ...payload });
    }
  });
}

function subscribeNewMsg({ channel, callback }) {
  channel.on(commandType.NEW_MSG, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.NEW_MSG}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.NEW_MSG, activityId, ...payload });
    }
  });
}

function subscribeNewAttachment({ channel, callback }) {
  channel.on(commandType.NEW_ATTACHMENT, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.NEW_ATTACHMENT}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.NEW_ATTACHMENT, activityId, data: payload });
    }
  });
}

function subscribeDeleteAttachment({ channel, callback }) {
  channel.on(commandType.DELETED_ATTACHMENT, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.DELETED_ATTACHMENT}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.DELETED_ATTACHMENT, activityId, data: payload });
    }
  });
}

function subscribeInvalidAttachment({ channel, callback }) {
  channel.on(commandType.INVALID_ATTACHMENT, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.INVALID_ATTACHMENT}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.INVALID_ATTACHMENT, activityId, data: payload });
    }
  });
}
function subscribeNewMsgFromDepartment({ channel, callback }) {
  channel.on(commandType.NEW_MSG_FROM_DEPARTMENT, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.NEW_MSG_FROM_DEPARTMENT}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.NEW_MSG_FROM_DEPARTMENT, activityId, ...payload });
    }
  });
}

function subscribeNewDepartAttachment({ channel, callback }) {
  channel.on(commandType.NEW_DEPARTMENT_ATTACHMENT, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.NEW_DEPARTMENT_ATTACHMENT}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.NEW_DEPARTMENT_ATTACHMENT, activityId, data: payload });
    }
  });
}

function subscribeDeletedDepartAttachment({ channel, callback }) {
  channel.on(commandType.DELETED_DEPARTMENT_ATTACHMENT, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.DELETED_DEPARTMENT_ATTACHMENT}),`
      + ` data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.DELETED_DEPARTMENT_ATTACHMENT, activityId, data: payload });
    }
  });
}

function subscribeInvalidDepartAttachment({ channel, callback }) {
  channel.on(commandType.INVALID_DEPARTMENT_ATTACHMENT, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.INVALID_DEPARTMENT_ATTACHMENT}),`
    + ` data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.INVALID_DEPARTMENT_ATTACHMENT, activityId, data: payload });
    }
  });
}

function subscribeInfo({ channel, callback }) {
  channel.on(commandType.INFO, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.INFO}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.INFO, activityId, ...payload });
    }
  });
}

function subscribeIsRead({ channel, callback }) {
  channel.on(commandType.IS_READ, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.IS_READ}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.IS_READ, activityId, ...payload });
    }
  });
}

function subscribeIsTyping({ channel, callback }) {
  channel.on(commandType.IS_TYPING, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.IS_TYPING}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.IS_TYPING, activityId, ...payload });
    }
  });
}

function subscribeOnInput({ channel, callback }) {
  channel.on(commandType.INPUT, (payload) => {
    l.info(`Пришло сообщение (команда ${commandType.INPUT}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
      callback({ type: commandType.INPUT, activityId, ...payload });
    }
  });
}

function subscribeLeft({ channel, callback }) {
  channel.on(commandType.LEFT, (payload) => {
    l.info(`Клиент вышел из активности (команда ${commandType.LEFT}), closedBy = ${payload.closedBy}`);
    l.info(`activityId = ${payload.activityId}`);
    if (typeof callback === 'function') {
      callback({
        type: commandType.LEFT,
        data: {
          activityId: payload.activityId,
          closedBy: payload.closedBy,
          csi: payload.csi,
          needProcessCsi: payload.needProcessCsi,
          topic: channel.topic,
        },
      });
    }
  });
}

function subscribeStopActivity({ channel, callback }) {
  channel.on(commandType.STOP_ACTIVITY, (state) => {
    l.info(`Активность была закрыта (команда ${commandType.STOP_ACTIVITY})`);
    if (typeof callback === 'function') {
      callback({
        type: commandType.STOP_ACTIVITY,
        data: {
          activityId: state.activityId,
          topic: channel.topic,
        },
      });
    }
  });
}

function subscribeOnholdActivity({ channel, callback }) {
  channel.on(commandType.ONHOLD_ACTIVITY, () => {
    l.info(`Активность была переведена в  (команда ${commandType.ONHOLD_ACTIVITY})`);
    const activityId = channel.topic.replace(`${channelTypes.ROOM}:`, '');
    if (typeof callback === 'function') {
      callback({ type: commandType.ONHOLD_ACTIVITY, activityId });
    } else {
      l.error(`Holding activity error. Callback is not a func for activiti Id: ${activityId}`);
    }
  });
}

function subscribeTransfered({ channel, callback }) {
  channel.on(commandType.TRANSFERED, (state) => {
    l.info(`Активность перенаправлена (команда ${commandType.TRANSFERED})`);
    l.info(`activityId = ${state.oldActivityId}`);
    if (typeof callback === 'function') {
      callback({
        type: commandType.TRANSFERED,
        data: {
          newActivityId: state.newActivityId,
          oldActivityId: state.oldActivityId,
          receivedAt: state.receivedAt,
          topic: channel.topic,
          subject: state.subject,
        },
      });
    }
  });
}

function subscribeChangeStatus({ channel, callback }) {
  channel.on(commandType.CHANGE_STATUS, (data) => {
    l.info(`Изменен статус оператора (команда ${commandType.CHANGE_STATUS}), data = ${JSON.stringify(data)}`);
    if (typeof callback === 'function') {
      callback({ type: commandType.CHANGE_STATUS, data });
    }
  });
}

function subscribeForceLogout({ channel, callback }) {
  channel.on(commandType.FORCE_LOGOUT, (data) => {
    l.warn('Получена событие о принужденном выходе из АРМ оператора'
      + ` (команда ${commandType.FORCE_LOGOUT}), data = ${JSON.stringify(data)}`);
    if (typeof callback === 'function') {
      callback({ type: commandType.FORCE_LOGOUT, data });
    }
  });
}

function subscribeSimultaneousLogin({ channel, callback }) {
  channel.on(commandType.SIMULTANEOUS_LOGIN, (data) => {
    l.warn('Получено уведомление об одновременном входе в АРМ оператора'
      + ` (команда ${commandType.SIMULTANEOUS_LOGIN}), data = ${JSON.stringify(data)}`);
    if (typeof callback === 'function') {
      callback({ type: commandType.SIMULTANEOUS_LOGIN, data });
    }
  });
}

function subscribeFoundOperator({ channel, callback }) {
  channel.on(commandType.FOUND_OPERATOR, (data) => {
    l.info(`Найден оператор (команда ${commandType.FOUND_OPERATOR}), data = ${JSON.stringify(data)}`);
    if (typeof callback === 'function') {
      callback({ type: commandType.FOUND_OPERATOR, data });
    }
  });
}

function subscribeStatistics({ channel, callback }) {
  channel.on(commandType.STATISTICS, (data) => {
    l.info(`Получена оперативная статистика с сервера (команда ${commandType.STATISTICS}),`
      + ` data = ${JSON.stringify(data)}`);
    if (typeof callback === 'function') {
      callback({ type: commandType.STATISTICS, data });
    }
  });
}
function subscribeOperationalReportsUpdate({ channel, callback }) {
  channel.on(commandType.OPERATIONAL_REPORTS_UPDATE, (data) => {
    l.info(`Получена оперативная статистика с сервера (команда ${commandType.OPERATIONAL_REPORTS_UPDATE}),`
      + ` data = ${JSON.stringify(data)}`);
    if (typeof callback === 'function') {
      callback({ type: commandType.OPERATIONAL_REPORTS_UPDATE, data });
    }
  });
}

function subscribeActivitiesQueue({ channel, callback }) {
  channel.on(commandType.ACTIVITY_QUEUE, (data) => {
    l.info(`Получена оперативная статистика по очередям с сервера (команда ${commandType.ACTIVITY_QUEUE}),`
      + ` data = ${JSON.stringify(data)}`);
    if (typeof callback === 'function') {
      callback({ type: commandType.ACTIVITY_QUEUE, data });
    }
  });
}

function subscribeAverageVotes({ channel, callback }) {
  const getAverageResults = 'Получена оперативная статистика по средним оценкам операторов';
  channel.on(commandType.CONSOLIDATED_EVALUATION, (data) => {
    l.info('Получена средняя консолидированная оценка '
      + `(команда ${commandType.CONSOLIDATED_EVALUATION}), data = ${JSON.stringify(data)}`);
    if (typeof callback === 'function') {
      callback({ type: commandType.CONSOLIDATED_EVALUATION, data });
    }
  });
  channel.on(commandType.AVERAGE_VOTES_FOR_OPERATORS, (data) => {
    l.info(getAverageResults
      .concat(` (команда ${commandType.AVERAGE_VOTES_FOR_OPERATORS}), data = ${JSON.stringify(data)}`));
    if (typeof callback === 'function') {
      callback({ type: commandType.AVERAGE_VOTES_FOR_OPERATORS, data });
    }
  });
  channel.on(commandType.AVERAGE_VOTES_FOR_REQUEST_TYPES, (data) => {
    l.info(getAverageResults
      .concat(` (команда ${commandType.AVERAGE_VOTES_FOR_REQUEST_TYPES}), data = ${JSON.stringify(data)}`));
    if (typeof callback === 'function') {
      callback({ type: commandType.AVERAGE_VOTES_FOR_REQUEST_TYPES, data });
    }
  });
  channel.on(commandType.AVERAGE_VOTES_FOR_CHANNELS, (data) => {
    l.info(getAverageResults
      .concat(` (команда ${commandType.AVERAGE_VOTES_FOR_CHANNELS}), data = ${JSON.stringify(data)}`));
    if (typeof callback === 'function') {
      callback({ type: commandType.AVERAGE_VOTES_FOR_CHANNELS, data });
    }
  });
}

function subscribeOperators({ channel, callback }) {
  channel.on(commandType.OPERATORS, (data) => {
    l.info(`Получены операторы с сервера (команда ${commandType.OPERATORS}), data = ${JSON.stringify(data)}`);
    if (typeof callback === 'function') {
      callback({ type: commandType.OPERATORS, data });
    }
  });
}

function subscribeError({
  channel, callback,
}) {
  channel.on(commandType.ERROR, (data) => {
    l.error(`Получена ошибка с сервера (команда ${commandType.ERROR}),`
      + ` канал: ${channel.topic}, data = ${JSON.stringify(data)}}`);
    if (typeof callback === 'function') {
      callback({ type: commandType.ERROR, data });
    }
  });
}

function subscribeSocketError({
  socket, callback,
}) {
  socket.onError((data) => {
    l.error(`Получена ошибка с сервера при попытке подключения к сокету, data = ${JSON.stringify(data)}`);
    if (typeof callback === 'function') {
      callback({ type: commandType.SOCKET_ERROR });
    }
  });
}

const reJoinTimers = {};
function reJoin(channel, callback) {
  const { topic } = channel;
  if (typeof reJoinTimers[topic] === 'undefined') {
    reJoinTimers[topic] = {
      tries: 0,
      timer: undefined,
    };
  }
  const temp = reJoinTimers[topic];
  temp.tries += 1;
  clearTimeout(temp.timer);

  if (temp.tries < 50) {
    temp.timer = setTimeout(() => {
      callback();
    }, retryAgain(temp.tries));
  }
}

function subscribeJoin({ channel, callback }) {
  const { topic } = channel;

  channel.join()
    .receive('ok', (response) => {
      if (typeof callback === 'function') {
        callback({
          type: commandType.JOIN,
          data: { topic, ...response.data },
        });
      }
      l.log('Joined successfully', response);
    })
    .receive('error', (response) => {
      if (response.commandType === commandType.UNABLE_TO_JOIN && typeof callback === 'function') {
        callback({
          type: commandType.UNABLE_TO_JOIN,
          data: { topic, ...response.data },
        });
      }

      l.error('Unable to join', response); // Changed the logging to include the entire response object.

      // Ensure response.reason exists and is a string before using indexOf.
      if (typeof response.reason === 'string') {
        if ((response.reason.indexOf('Activities limit is reached') !== -1
            || response.reason.indexOf('Incorrect activity') !== -1)
          && channels.get(`${topic}`) !== undefined) {
          channel.leave();
          channels.delete(`${topic}`);
        }

        if (response.reason === JOIN_CRASHED
          && !channel.isLeaving() && !channel.isClosed()) {
          reJoin(channel, () => {
            l.warn('Retry join again after join crashed:', { reason: response.reason });
            channel.joinedOnce = false;
            channel.join();
          });
        }
      }
    });
}

function subscribeOverseerReports({ channel, callback }) {
  channel.on(commandType.CSV_REPORT_FINISHED, (payload) => {
    if (typeof callback === 'function') {
      callback({ type: commandType.CSV_REPORT_FINISHED, data: payload });
    }
  });

  channel.on(commandType.CSV_REPORT_FAILED, (payload) => {
    if (typeof callback === 'function') {
      callback({ type: commandType.CSV_REPORT_FAILED, data: payload });
    }
  });

  channel.on(commandType.CSV_REPORT_CANCELLED, (payload) => {
    if (typeof callback === 'function') {
      callback({ type: commandType.CSV_REPORT_CANCELLED, data: payload });
    }
  });

  channel.on(commandType.CSV_REPORT_IN_PROGRESS, (payload) => {
    if (typeof callback === 'function') {
      callback({ type: commandType.CSV_REPORT_IN_PROGRESS, data: payload });
    }
  });
}

const subscribeRoomEvents = (id, username, token, socket, channel, callback, enableSendingLogs, userInfo) => {
  l.info(`Пользователь ${username} (id = ${id})`
    + ` подписывается на события: ${commandType.NEW_MSG}, ${commandType.TRANSFERED},`
    + ` ${commandType.LEFT}, ${commandType.FOUND_OPERATOR}, ${commandType.NEW_ATTACHMENT},`
    + ` ${commandType.ONHOLD_ACTIVITY}`);

  subscribeNewMsg({ channel, callback });
  subscribeNewMsgFromDepartment({ channel, callback });
  subscribeInfo({ channel, callback });
  subscribeLeft({ channel, callback });
  subscribeTransfered({ channel, callback });
  subscribeError({
    channel, callback, enableSendingLogs, userInfo,
  });
  subscribeFoundOperator({ channel, callback });
  subscribeStopActivity({ channel, callback });
  subscribeIsRead({ channel, callback });
  subscribeIsTyping({ channel, callback });
  subscribeOnInput({ channel, callback });
  subscribePresence({ channel, callback });
  subscribeJoin({ channel, callback });
  subscribeSocketError({
    socket, callback, enableSendingLogs, userInfo,
  });
  subscribeNewAttachment({ channel, callback });
  subscribeDeleteAttachment({ channel, callback });
  subscribeInvalidAttachment({ channel, callback });
  subscribeNewDepartAttachment({ channel, callback });
  subscribeDeletedDepartAttachment({ channel, callback });
  subscribeInvalidDepartAttachment({ channel, callback });
  subscribeOnholdActivity({ channel, callback });
};

function subscribeNewActivity({
  channel,
  callback,
}) {
  channel.on(commandType.NEW_ACTIVITY, (payload) => {
    const activityId = payload.id;
    l.info(`Доступна новая активность ${activityId}`
      + `  (команда ${commandType.NEW_ACTIVITY}), data = ${JSON.stringify(payload)}`);
    if (typeof callback === 'function') {
      callback({ type: commandType.NEW_ACTIVITY, activity: payload });
    }
  });
}

const subscribeEvents = (id, username, token, socket, channel, callback, enableSendingLogs, userInfo) => {
  l.info(`Пользователь ${username} (id = ${id}) подписывается на события: ${commandType.NEW_MSG},
  ${commandType.TRANSFERED}, ${commandType.NEW_ACTIVITY}, ${commandType.LEFT}, ${commandType.CHANGE_STATUS}`);

  subscribeNewActivity({ channel, callback });
  subscribeNewMsg({ channel, callback });
  subscribeNewMsgFromDepartment({ channel, callback });
  subscribeIsRead({ channel, callback });
  subscribeIsTyping({ channel, callback });
  subscribeOnInput({ channel, callback });
  subscribeLeft({ channel, callback });
  subscribeTransfered({ channel, callback });
  subscribeChangeStatus({ channel, callback });
  subscribeForceLogout({ channel, callback });
  subscribeSimultaneousLogin({ channel, callback });
  subscribeOperators({ channel, callback });
  subscribeStatistics({ channel, callback });
  subscribeOperationalReportsUpdate({ channel, callback });
  subscribeActivitiesQueue({ channel, callback });
  subscribeAverageVotes({ channel, callback });
  subscribeError({
    channel, callback, enableSendingLogs, userInfo,
  });
  subscribeFoundOperator({ channel, callback });
  subscribeJoin({ channel, callback });
  subscribeSocketError({
    socket, callback, enableSendingLogs, userInfo,
  });
  subscribeNewAttachment({ channel, callback });
  subscribeDeleteAttachment({ channel, callback });
  subscribeInvalidAttachment({ channel, callback });
  subscribeNewDepartAttachment({ channel, callback });
  subscribeDeletedDepartAttachment({ channel, callback });
  subscribeInvalidDepartAttachment({ channel, callback });
  subscribeOverseerReports({ channel, callback });
};

const subscribe = async ({
  channelType,
  id,
  username,
  token,
  callback,
}) => {
  try {
    const socket = await createSocket(token);
    const currentChannel = channels.get(`${channelType}:${id}`);

    if (!currentChannel) {
      const channel = createChannel(socket, channelType, id, token);
      if (channelType === channelTypes.ROOM) {
        subscribeRoomEvents(id, username, token, socket, channel, callback);
      } else {
        subscribeEvents(id, username, token, socket, channel, callback);
      }
    }
  } catch (error) {
    l.error('Ошибка при подключении к сокету:', error);
  }
};

export {
  subscribe,
  isSubscribe,
  unSubscribe,
  disconnect,
  socketEventEmitter,
};
